import { getAuthHeader } from "./auth";

export const PROD_API_URL = "https://theqahubweb-production.up.railway.app";
export const ENV_API_URL = (process.env.REACT_APP_API_URL || "").trim().replace(/\/$/, "");
export const CURRENT_ORIGIN = typeof window !== "undefined" ? window.location.origin : "";
export const NORMALIZED_ORIGIN = CURRENT_ORIGIN.includes("://www.theqahub.es")
  ? CURRENT_ORIGIN.replace("://www.", "://")
  : CURRENT_ORIGIN;
const DEFAULT_FETCH_TIMEOUT_MS = 2500;

export const getStoredApiUrl = () => {
  if (typeof window === "undefined") return "";
  try {
    return window.localStorage.getItem("theqahub_api_base") || "";
  } catch {
    return "";
  }
};

export const getApiCandidates = () => {
  const candidates = [];
  const storedApiUrl = getStoredApiUrl();
  const isPublicSiteOrigin = CURRENT_ORIGIN.includes("theqahub.es");
  const directApiUrl = ENV_API_URL || PROD_API_URL;
  const altOrigin = NORMALIZED_ORIGIN.includes("theqahub.es")
    ? (NORMALIZED_ORIGIN.includes("://www.")
        ? NORMALIZED_ORIGIN.replace("://www.", "://")
        : NORMALIZED_ORIGIN.replace("://", "://www."))
    : "";

  const pushUnique = (value) => {
    if (!value || candidates.includes(value)) return;
    candidates.push(value);
  };

  pushUnique(storedApiUrl);

  if (isPublicSiteOrigin) {
    // In production the frontend is served by Vercel, but the API lives on Railway.
    // Prefer the direct API host first so we avoid /api proxy redirects and 502s.
    pushUnique(directApiUrl);
    pushUnique(NORMALIZED_ORIGIN);
    pushUnique(altOrigin);
    pushUnique(CURRENT_ORIGIN);
  } else {
    pushUnique(directApiUrl);
    pushUnique(NORMALIZED_ORIGIN);
    pushUnique(CURRENT_ORIGIN);
    pushUnique(altOrigin);
  }

  return candidates;
};

export const getApiBaseUrl = () => {
  const [firstCandidate = ""] = getApiCandidates();
  return firstCandidate;
};

export const storeApiBaseUrl = (baseUrl) => {
  if (!baseUrl || typeof window === "undefined") return;
  try {
    window.localStorage.setItem("theqahub_api_base", baseUrl);
  } catch {}
};

const fetchWithTimeout = async (url, options = {}, timeoutMs = DEFAULT_FETCH_TIMEOUT_MS) => {
  const controller = typeof AbortController !== "undefined" ? new AbortController() : null;
  const timeoutId = controller
    ? setTimeout(() => controller.abort(), timeoutMs)
    : null;

  try {
    return await fetch(url, {
      ...options,
      signal: controller?.signal || options.signal,
    });
  } finally {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  }
};

export const fetchCurrentUser = async () => {
  for (const baseUrl of getApiCandidates()) {
    try {
      const res = await fetchWithTimeout(`${baseUrl}/api/auth/me`, {
        method: "GET",
        credentials: "include",
        headers: {
          ...getAuthHeader(),
        },
      });
      const data = await res.json().catch(() => ({}));

      if (res.ok && data.user) {
        storeApiBaseUrl(baseUrl);
        return { user: data.user, baseUrl };
      }
    } catch {}
  }

  return { user: null, baseUrl: "" };
};

export const fetchJsonFromApiCandidates = async (path, options = {}) => {
  let lastError = null;
  const { timeoutMs = DEFAULT_FETCH_TIMEOUT_MS, ...requestOptions } = options;

  for (const baseUrl of getApiCandidates()) {
    try {
      const res = await fetchWithTimeout(`${baseUrl}${path}`, requestOptions, timeoutMs);
      const data = await res.json().catch(() => null);

      if (!res.ok) {
        lastError = new Error(`Request failed with status ${res.status}`);
        continue;
      }

      storeApiBaseUrl(baseUrl);
      return { data, baseUrl };
    } catch (error) {
      lastError = error;
    }
  }

  throw lastError || new Error("No API candidate responded successfully");
};

export const fetchTextFromApiCandidates = async (path, options = {}) => {
  let lastError = null;
  const { timeoutMs = DEFAULT_FETCH_TIMEOUT_MS, ...requestOptions } = options;

  for (const baseUrl of getApiCandidates()) {
    try {
      const res = await fetchWithTimeout(`${baseUrl}${path}`, requestOptions, timeoutMs);
      const text = await res.text();

      if (!res.ok) {
        lastError = new Error(`Request failed with status ${res.status}`);
        continue;
      }

      storeApiBaseUrl(baseUrl);
      return { text, baseUrl };
    } catch (error) {
      lastError = error;
    }
  }

  throw lastError || new Error("No API candidate responded successfully");
};
